import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

import Why from './pages/Why'
import Roadmap from './pages/Roadmap'
import WhatIs from './pages/WhatIs'
import Compare from './pages/Compare'
import GithubDeployProject from './pages/GithubDeployProject'
import Docs from './pages/Docs'
import OpendeployCapabilitiesDocs from './pages/OpendeployCapabilitiesDocs'
import Fde from './pages/Fde'
import Llm from './pages/Llm'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import { VERCEL, RAILWAY, RENDER } from './pages/vs.data'
import BetaModal from './components/BetaModal'
import ContactModal from './components/ContactModal'
import ScrollToTop from './components/ScrollToTop'

import './styles/reset.css'
import './styles/landing-v2.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <BetaModal />
        <ContactModal />
        <Routes>
          <Route path="/" element={<Llm />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="/docs/what-ShimmerTech-can-do" element={<OpendeployCapabilitiesDocs />} />
          <Route path="/docs/agent-platforms-plugins-skills" element={<Navigate to="/docs" replace />} />
          <Route path="/start" element={<Navigate to="/" replace />} />
          <Route path="/blog" element={<Navigate to="/" replace />} />
          <Route path="/blog/:slug" element={<Navigate to="/" replace />} />
          <Route path="/events" element={<Navigate to="/" replace />} />
          <Route path="/events/:slug" element={<Navigate to="/" replace />} />
          <Route path="/templates" element={<Navigate to="/" replace />} />
          <Route path="/templates/:slug" element={<Navigate to="/" replace />} />
          <Route path="/fde" element={<Fde />} />
          <Route path="/llm" element={<Navigate to="/" replace />} />
          <Route path="/why" element={<Why />} />
          <Route path="/thesis" element={<Navigate to="/why" replace />} />
          <Route path="/how" element={<Navigate to="/#how" replace />} />
          <Route path="/pricing" element={<Navigate to="/" replace />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/changelog" element={<Navigate to="/" replace />} />
          <Route path="/what-is-ShimmerTech" element={<WhatIs />} />
          <Route path="/github/:owner/:repo" element={<GithubDeployProject />} />
          <Route path="/vs/vercel" element={<Compare data={VERCEL} />} />
          <Route path="/vs/railway" element={<Compare data={RAILWAY} />} />
          <Route path="/vs/render" element={<Compare data={RENDER} />} />
          <Route path="/auth/callback" element={<Navigate to="/" replace />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
)
